class XmlDoc {
  
    constructor(doc) {
      this.doc = doc;
    }
  
    children() {
      return this.getChildrenOf(this.doc);
    }
  
    getChildrenOf(node) {
      return [].slice.call(node.children);
    }
  
    childAt(nodeName) {
      const node = this.getNodeAt(nodeName);
      return new XmlDoc(node);
    }
  
    nodeChildAt(node, nodeName) {
      return this.getChildrenOf(node)
                 .find(c =>
                           c.nodeName.toLowerCase()
                            .includes(nodeName.toLowerCase()),
                 );
    }
  
    getNodeAt(nodeName) {
      const childNodeNames = nodeName.split('/');
      let node = this.doc;
      childNodeNames.forEach(name => {
        node = this.nodeChildAt(node, name);
      });
      return node;
    }
  
    setNodeAt(nodeName) {
      this.doc = this.getNodeAt(nodeName);
    }
  
    text() {
      return this.doc.textContent.trim();
    }
  }
  
  export default XmlDoc;